import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";

export const useCanReply = (item: ReviewItemFieldsFragment): boolean => {
  const isPeerReviewEnabled = useIsPeerReviewEnabled();

  return isPeerReviewEnabled && item.__typename === "ReportCommentType";
};
